<template>
    <div class="activities">
        <ScrollDownDiv style="flex-grow:1;overflow-y: auto;">
            <template v-for="(activity, activityIndex) in activities">
                <SpeechBubble :activity="activity"  :key="activityIndex" class="mb-3"/>
            </template>
        </ScrollDownDiv>
        <div style="flex-basis:40px;">
            <input v-model="newCommentText" @keydown.enter.prevent="saveComment" type="text" class="add-comment-box" placeholder="Add a comment...">
        </div>
    </div>
</template>

<script>

import SpeechBubble from '@/flow/ui/SpeechBubble'
import Security from '@/data/Security'
import ScrollDownDiv from '@/ui-elements/ScrollDownDiv'

export default {

    data() {
        return {
            newCommentText: ''
        }
    },

    components: {
        SpeechBubble, ScrollDownDiv
    },
    
    props: {
        activities: Array,
    },

    computed: {

    },

    methods: {
        saveComment() {
            if(!this.newCommentText)
                return

            const activity = {description: this.newCommentText, uid: Security.getMyId()}
            this.activities.push(activity)

            this.newCommentText = ''
        }

    },

    created() {

    }
}
</script>

<style scoped>
    .activities {
        display:flex; flex-direction:column;
    }
    .add-comment-box {
        border: none; background-color: rgba(0,0,0,0.06);
        border-radius:50px; padding: 7px 15px; width:100%;
    }
    .add-comment-box:focus {
        outline: none;
        background-color:rgba(0,0,0,0.1)

    }
    .add-comment-box::placeholder {
        color:#aaa;
    }

</style>




// WEBPACK FOOTER //
// Activities.vue?968ab000